import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "icon", "text", "createButton"]
  static values = { visible: Boolean }

  connect() {
    // Initialize state based on value
    this.updateVisibility()
    this.updateButton()
  }

  toggle(event) {
    event.preventDefault()
    this.visibleValue = !this.visibleValue
  }

  visibleValueChanged() {
    this.updateVisibility()
    this.updateButton()
  }

  updateVisibility() {
    const isVisible = this.visibleValue
    
    this.contentTargets.forEach(el => {
      el.style.display = isVisible ? "" : "none"
    })

    this.createButtonTargets.forEach(el => {
      el.style.display = isVisible ? "" : "none"
    })
  }

  updateButton() {
    if (!this.hasButtonTarget) return

    const isVisible = this.visibleValue
    const btn = this.buttonTarget
    
    // Update classes
    if (btn.classList.contains('btn')) {
      btn.classList.toggle("btn-primary", isVisible)
      btn.classList.toggle("btn-secondary", !isVisible)
    }

    // Update Icon if present
    if (this.hasIconTarget) {
      this.iconTarget.textContent = isVisible ? "▼" : "▶"
    }

    // Update Text if present
    if (this.hasTextTarget) {
      this.textTarget.textContent = isVisible ? " Hide Admin Edit" : " Show Admin Edit"
    }
  }
}
